import { render, staticRenderFns } from "./RmpInformationMenu.vue?vue&type=template&id=0aadf322&scoped=true"
import script from "./RmpInformationMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./RmpInformationMenu.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RmpInformationMenu.vue?vue&type=style&index=0&id=0aadf322&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aadf322",
  null
  
)

export default component.exports